import { render, staticRenderFns } from "./QuestionsCategoryPage.vue?vue&type=template&id=24f62155&"
import script from "./QuestionsCategoryPage.vue?vue&type=script&lang=js&"
export * from "./QuestionsCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsCategoryPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports